export default {
  path: '',
  component: () => import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
  children: [
    {
      path: '/distributor/tour/back',
      component: () => import('@/page/distributor/component/admin-layout/index.vue'),
      children: [
        {
          path: '/distributor/tour/back/authentication-result',
          name: 'distributor-tour-back-authentication-result',
          component: () => import('@/page/distributor/tour/back/personal-center/authentication-result/index.vue'),
          meta: {
            nav_list_for_admin_layout_head_nav: [
              {name: `个人中心`},
              {name: `实名认证结果`},
            ],
          },
        },
      ]
    },
  ]
};
